import type { DashboardEventDateParts } from "../_utils/dashboardEventDisplay";
import { useIsDashboardStackedTableRows } from "../_hooks/useIsDashboardSingleColumn";
import classNames from "classnames";

type DashboardEventDateProps = {
  date: DashboardEventDateParts;
};

export default function DashboardEventDate({ date }: DashboardEventDateProps) {
  const isStackedTableRows = useIsDashboardStackedTableRows();

  return (
    <div>
      <div
        className={classNames("text-body-medium text-sys-brand-on-surface", {
          "whitespace-nowrap": !isStackedTableRows
        })}
      >
        {date.primary}
      </div>
      {date.secondary ? (
        <div
          className={classNames("text-body-small text-sys-brand-on-surface-variant", {
            "whitespace-nowrap": !isStackedTableRows
          })}
        >
          {date.secondary}
        </div>
      ) : null}
    </div>
  );
}
